import React from 'react'
import SatsueiDataFormArea from '../shared/SatsueiDataFormArea'

const SatsueiDataTorokuFormArea = (props) => {
  return (
    <SatsueiDataFormArea
      mode="edit"
      {...props}
    />
  )
}

export default SatsueiDataTorokuFormArea
